<template>
    <div>
        <section class="about_us section-padding">
            <quienesSomos :quienesdata="config"/>
        </section>
            <porqueElegirnos/>
    </div>
</template>

<script>
    import quienesSomos from './frontQuienesSomos';
    import porqueElegirnos from './frontPorqueElegirnos';
    export default {
        props: ['config'],
        components: {
            quienesSomos,
            porqueElegirnos
        },
        
    }
</script>

<style lang="scss" scoped>

</style>